module.exports = __webpack_public_path__ + "img/tyg_solution3.d0e93b71.png";